import React, { useState } from 'react';
import { AutoComplete, Form, message } from 'antd';
import api, { formatApiError } from '../utils/api';

// Channel select-or-type box. If the typed channel is not in the list, an
// "add" option creates it (it then also shows in YouTube Channels).
export default function VtChannelField({ form, name = 'channel_name', label = 'Channel (select karo ya naam type karo)', rules, dependencies, channels, onAdded }) {
  const [typed, setTyped] = useState('');
  const t = typed.trim();
  const exists = !t || channels.some(c => (c.channel_name || '').trim().toLowerCase() === t.toLowerCase());
  const options = channels
    .filter(c => !t || (c.channel_name || '').toLowerCase().includes(t.toLowerCase()))
    .map(c => ({ value: c.channel_name }));
  if (!exists) {
    options.unshift({ value: t, isNew: true, label: <b style={{ color: '#1677ff' }}>+ "{t}" naya channel add karo (YouTube Channels me bhi aayega)</b> });
  }

  const onSelect = async (value, opt) => {
    if (!opt?.isNew) return;
    try {
      const res = await api.post('/video-tracker/add-channel', { channel_name: value });
      message.success(res.data.existing ? `Channel "${res.data.channel_name}" pehle se hai` : `Channel "${res.data.channel_name}" add ho gaya`);
      onAdded && onAdded({ id: res.data.id, channel_name: res.data.channel_name });
      form.setFieldsValue({ [name]: res.data.channel_name });
      setTyped('');
    } catch (err) { message.error(formatApiError(err, 'Channel add nahi hua')); }
  };

  return (
    <Form.Item name={name} label={label} rules={rules} dependencies={dependencies}
      extra="List me channel nahi hai? Naam likho aur '+ naya channel add karo' chuno">
      <AutoComplete allowClear options={options} filterOption={false} onSearch={setTyped} onSelect={onSelect}
        placeholder="Apna channel select karo ya naam likho" />
    </Form.Item>
  );
}
